export const controversyPhrases = [
  "Eu nunca mandei mensagem bêbado.",
  "Eu nunca mandei nudes.",
  "Eu nunca entupi a privada e coloquei a culpa em outra pessoa.",
  "Eu nunca estive fora da lei.",
  "Eu nunca prometi que ia esquecer alguém.",
  "Eu nunca dei um fora.",
  "Eu nunca disse que prestava.",
  "Eu nunca sumi e fiquei sem responder.",
  "Eu nunca levei um fora.",
  "Eu nunca usei um perfil fake nas redes sociais.",
  "Eu nunca curti minha própria foto ou post.",
  "Eu nunca vi coisa mais bela que uma pessoa dessa roda.",
  "Eu nunca mais vou dormir (uh, é Michael Douglas!)",
  "Eu nunca quis o coração de alguém.",
  "Eu nunca mandei mensagem para ex.",
  "Eu nunca falsifiquei documentos.",
  "Eu nunca entrei de bico em uma festa.",
  "Eu nunca fiz xixi na calça.",
  "Eu nunca fiz xixi na piscina.",
  "Eu nunca fiz xixi na rua.",
  "Eu nunca caguei em um banheiro químico.",
  "Eu nunca fiz uma loucura por amor.",
  "Eu nunca sofri um acidente.",
  "Eu nunca tive uma experiência paranormal.",
  "Eu nunca menti jogando eu nunca.",
  "Eu nunca desisti de uma amizade.",
  "Eu nunca fui corno.",
  "Eu nunca chifrei.",
  "Eu nunca me arrependi do meu voto.",
  "Eu nunca coloquei a culpa em um amigo.",
  "Eu nunca levei uma multa.",
  "Eu nunca fingi que estava passando mal para não ir trabalhar.",
  "Eu nunca pedi dinheiro emprestado e fingi que esqueci.",
  "Eu nunca tomei remédio tarja preta.",
  "Eu nunca fui em um lugar de propósito para encontrar meu ex.",
  "Eu nunca grudei chiclete no cabelo de alguém.",
  "Eu nunca usei atestado médico falso.",
  "Eu nunca subornei.",
  "Eu nunca subestimei a capacidade de alguém.",
  "Eu nunca tive vontade de matar alguém.",
  "Eu nunca passei trote.",
  "Eu nunca fingi que estava bêbado.",
  "Eu nunca dirigi bêbado.",
  "Eu nunca depilei o ânus.",
  "Eu nunca fingi que estava chorando.",
  "Eu nunca vomitei pelo nariz.",
  "Eu nunca pensei que estava sendo perseguido.",
  "Eu nunca caguei no mato.",
  "Eu nunca fiz questão de estar aqui.",
  "Eu nunca quebrei a cara.",
  "Eu nunca me apaixonei.",
  "Eu nunca tomei um porre porque estava na fossa.",
  "Eu nunca usei roupa com etiqueta para trocar depois.",
  "Eu nunca tive um relacionamento aberto.",
  "Eu nunca editei uma foto para parecer mais magro/gostoso.",
  "Eu nunca me humilhei por causa de alguém.",
  "Eu nunca tive que correr para salvar a minha vida.",
  "Eu nunca estive em um tiroteio.",
  "Eu nunca estive envolvido em uma catástrofe natural.",
  "Eu nunca pedi dinheiro na rua.",
  "Eu nunca estraguei a viagem de alguém.",
  "Eu nunca beijei alguém do mesmo sexo.",
  "Eu nunca fiz topless.",
  "Eu nunca tive vergonha de assumir meu voto publicamente.",
  "Eu nunca menti em uma entrevista de emprego.",
  "Eu nunca fiquei trancado para fora de casa.",
  "Eu nunca gritei no travesseiro.",
  "Eu nunca fui operado.",
  "Eu nunca menti a idade.",
  "Eu nunca chorei na escola.",
  "Eu nunca pensei que alguma coisa fosse mal assobrada.",
  "Eu nunca tomei um capote de bicicleta.",
  "Eu nunca sofri um acidente.",
  "Eu nunca jantei doces.",
  "Eu nunca fiz xixi na cama depois de criança.",
  "Eu nunca dei vexame.",
  "Eu nunca cheirei o chulé de alguém",
  "Eu nunca deixei alguém cheirar meus dedos.",
  "Eu nunca comi escondido para não oferecer.",
  "Eu nunca escondi comida no meu quarto.",
  "Eu nunca menti para as autoridades.",
  "Eu nunca xinguei a mãe do juíiz.",
  "Eu nunca fumei cigarro.",
  "Eu nunca estacionei em vaga de idoso/deficientes.",
  "Eu nunca furei o sinal vermelho.",
  "Eu nunca quase atropelei alguém.",
  "Eu nunca pedi comida porque tinha preguiça de cozinhar.",
  "Eu nunca viajei sozinho.",
  "Eu nunca fui viciado em alguma coisa.",
  "Eu nunca fiz terapia.",
  "Eu nunca misturei bebidas super fortes.",
  "Eu nunca me deparei com um inseto venenoso.",
  "Eu nunca escrevi uma carta de ódio.",
  "Eu nunca sugeri brincar de eu nunca apenas para descobrir os segredos de alguém.",
  "Eu nunca usei fraldas depois de adulto.",
  "Eu nunca fertilizei minhas plantas com algo incomum",
  "Eu nunca tive um corte de cabelo ridículo.",
  "Eu nunca dei bafão na festa da firma.",
  "Eu nunca discuti no almoço de família.",
  "Eu nunca abandonei um grupo de WhatsApp.",
  "Eu nunca fui à Igreja.",
  "Eu nunca roubei alguma coisa do bar.",
  "Eu nunca fiz careta para crianças.",
  "Eu nunca copiei perguntas de eu nunca de outro site.",
  "Eu nunca roubei uma ideia.",
  "Eu nunca fui discriminado.",
  "Eu nunca fui machista.",
  "Eu nunca sofri machismo.",
  "Eu nunca fui demitido.",
  "Eu nunca demiti alguém.",
  "Eu nunca apostei dinheiro.",
  "Eu nunca vesti a camisa de outro time.",
  "Eu nunca mudei de religião.",
  "Eu nunca perdi um amigo por política.",
  "Eu nunca chorei de raiva por política.",
  "Eu nunca fui antiético.",
  "Eu nunca misturei remédios e álcool.",
  "Eu nunca tive diarreia e não conseguir chegar até o banheiro.",
  "Eu nunca fumei haxixe.",
  "Eu nunca usei documento falso.",
  "Eu nunca menti que eu era estudante para pagar meia entrada.",
  "Eu nunca fiquei com alguém de outra nacionalidade.",
  "Eu nunca caguei na balada.",
  "Eu nunca quis ficar com um amigo ou amiga.",
  "Eu nunca fui vegetariano.",
  "Eu nunca me arrumei antes da pessoa que estava dormindo comigo acordar para me ver bonit@.",
  "Eu nunca tive uma dívida.",
  "Eu nunca precisei pedir dinheiro emprestado.",
  "Eu nunca dei barraco.",
  "Eu nunca senti que alguém era muito bonito para mim.",
  "Eu nunca fiquei com mais do que 1 pessoa em 1 festa/noite.",
  "Eu nunca fui em uma micareta.",
  "Eu nunca quebrei alguma coisa e coloquei a culpa em outra pessoa.",
  "Eu nunca tomei tequila.",
  "Eu nunca dei um presente usado.",
  "Eu nunca assisti filme sem pagar.",
  "Eu nunca fiz faxina.",
  "Eu nunca tive uma alucinação.",
  "Eu nunca tomei Ayahuasca.",
  "Eu nunca comi cogumelos alucinógenos.",
  "Eu nunca fiz campanha política.",
  "Eu nunca me arrependi por ter votado em alguém.",
  "Eu nunca acordei sem saber onde estava.",
  "Eu nunca mudei de opinião só para agradar alguém.",
  "Eu nunca emprestei algo que não me devolveram.",
  "Eu nunca fiquei com uma pessoa de outro país.",
  "Eu nunca beijei um parente um amigo.",
  "Eu nunca fiz o mapa astral do crush.",
  "Eu nunca beijei alguém com bafo.",
  "Eu nunca fui assediado.",
  "Eu nunca cometi um grande erro na minha vida.",
  "Eu nunca estraguei um relacionamento.",
  "Eu nunca fui a um local proibidão.",
  "Eu nunca perdi um dente.",
  "Eu nunca copiei uma declaração de amor.",
  "Eu nunca fingi que estava gostando de uma comida e depois cuspi.",
  "Eu nunca me senti odiado.",
  "Eu nunca tive rancor de algo do passado.",
  "Eu nunca beijei na boca.",
  "Eu nunca joguei na loteria.",
  "Eu nunca namorei.",
  "Eu nunca menti para conseguir um trabalho.",
  "Eu nunca stalkeio as redes sociais de um ex.",
  "Eu nunca vivi um romance virtual.",
  "Eu nunca imaginei minha vida inteira ao lado de alguém impossível.",
  "Eu nunca tive dúvidas sobre a minha orientação sexual.",
  "Eu nunca menti que amava alguém.",
  "Eu nunca fiz um publi post.",
  "Eu nunca fiz coisas proibidas no local de trabalho.",
  "Eu nunca fui procurado pela polícia.",
  "Eu nunca apanhei.",
  "Eu nunca bebi até cair.",
  "Eu nunca brinquei de Eu Nunca com alguém da minha família.",
  "Eu nunca fiquei com alguém só porque a pessoa era boa de cama.",
  "Eu nunca deixei de falar com alguém por orgulho.",
  "Eu nunca menti para meu namorado.",
  "Eu nunca acreditei em notícias falsas.",
  "Eu nunca discuti por política.",
  "Eu nunca fiquei com alguém por interesse.",
  "Eu nunca me envolvi em uma polêmica.",
  "Eu nunca ganhei dinheiro com a internet.",
  "Eu nunca perdi dinheiro com a internet.",
  "Eu nunca xinguei muito no Twitter.",
  "Eu nunca fiquei triste por não me sentir bonita.",
  "Eu nunca tive problemas de autoestima.",
  "Eu nunca paguei peitinho na praia.",
  "Eu nunca senti que não merecia um elogio.",
  "Eu nunca tive vergonha de ficar pelado na frente de alguém.",
  "Eu nunca não acreditei que alguém era afim de mim.",
  "Eu nunca continuei usando a conta do Netflix de um ex.",
  "Eu nunca recusei um presente.",
  "Eu nunca sofri preconceito.",
  "Eu nunca tive medo de sair na rua.",
  "Eu nunca tive uma amizade colorida.",
  "Eu nunca me escondi de alguém na rua.",
  "Eu nunca senti ciúmes de um amigo.",
  "Eu nunca depilei as partes íntimas.",
  "Eu nunca pedi perdão por algo que não me sentia culpado.",
  "Eu nunca algemei alguém.",
  "Eu nunca tive medo de um filme de terror.",
];
